export default "__VITE_ASSET__Bj4oX7iH__"